import { useState } from 'react';

const useDragState = ({
  defaultTranslate
}) => {
  const [activeId, setActiveId] = useState(null);
  const [transformState, setTransformState] = useState({
    initialTranslate: defaultTranslate,
    translate: defaultTranslate
  });
  return {
    activeId,
    setActiveId,
    transformState,
    setTransformState
  };
};

export { useDragState };
